import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();
const htmlLangByLanguage = { FR: 'fr', EN: 'en', DE: 'de' };

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Récupère la langue depuis localStorage, sinon FR par défaut
    return localStorage.getItem('language') || 'FR';
  });

  // Sauvegarde la langue dans localStorage chaque fois qu'elle change
  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = htmlLangByLanguage[language] || 'fr';
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook pour utiliser la langue partout
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage doit être utilisé dans LanguageProvider');
  }
  return context;
};
